var exports = {
  "HM": "UserAreaSkeleton.module__userArea___ZzBUWF",
  "nd": "UserAreaSkeleton.module__panel___ZzBUWF",
  "zl": "UserAreaSkeleton.module__voicePanel___ZzBUWF",
  "Qs": "UserAreaSkeleton.module__content___ZzBUWF",
  "D_": "UserAreaSkeleton.module__identity___ZzBUWF",
  "Ky": "UserAreaSkeleton.module__identityText___ZzBUWF",
  "S7": "UserAreaSkeleton.module__nameRow___ZzBUWF",
  "jf": "UserAreaSkeleton.module__statusRow___ZzBUWF",
  "ne": "UserAreaSkeleton.module__controls___ZzBUWF",
};

module.exports = exports;
